import { useSuspenseQuery } from '@tanstack/react-query';
import { createFileRoute } from '@tanstack/react-router';

import { getTechnologicalTransferOptions } from '@/module/Author/TechnologicalTransfer';
import { TechnologicalTransferEdit } from '@/module/Author/TechnologicalTransfer/TechnologicalTransferEdit';

export const Route = createFileRoute(
  '/_auth/author/_author/technological-transfer/_technologicalTransfer/$technologicalTransferId/_layout/edit',
)({
  component: RouteComponent,
  staticData: {
    pageTitle: { id: 'pageTitle.edit' },
  },
});

function RouteComponent() {
  const { technologicalTransferId } = Route.useParams();
  const { data: technologicalTransfer } = useSuspenseQuery(getTechnologicalTransferOptions(technologicalTransferId));

  return <TechnologicalTransferEdit technologicalTransfer={technologicalTransfer} />;
}
